<template>
  <div style="height: 100%">
    <div class="headers_box" v-if="isheaders == 0">
      <el-menu
        @select="handleSelect"
        :text-color="isheaders == 0 ? '#fff' : '#2C2C2E'"
        :background-color="isheaders == 0 ? 'rgba(0, 0, 0, 0.8)' : '#f9f9f9'"
        :active-text-color="isheaders == 0 ? '#fff' : '#2C2C2E'"
        :default-active="activeIndex"
        class="el-menu-middle moblie-menu"
        mode="horizontal"
        ref="kzMenu"
      >
        <template v-for="(item, index) in menuArr">
          <!-- 有子菜单 -->
          <el-submenu
            popper-class="test"
            v-if="item.children"
            :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            :key="index"
          >
            <template slot="title">
              <span>{{ langSet == "cn" ? item.name_cn : item.name_en }}</span>
            </template>

            <el-menu-item
              v-for="(n, i) in item.children"
              :key="i"
              :index="
                langSet == 'cn'
                  ? n.http_url_cn !== '/download'
                    ? n.http_url_cn
                    : n.http_url_cn + '/' + n.id
                  : n.http_url_en !== '/download'
                  ? n.http_url_en
                  : n.http_url_en + '/' + n.id
              "
            >
              <template>
                <span slot="title">{{
                  langSet == "cn" ? n.name_cn : n.name_en
                }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
          <!-- 没有子菜单 -->
          <el-menu-item
            v-else
            :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            :key="index"
          >
            <span slot="title">{{
              langSet == "cn" ? item.name_cn : item.name_en
            }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="headers_slide_box" v-if="isheaders == 1">
      <el-menu
        @select="handleSelect"
        :text-color="isheaders == 0 ? '#fff' : '#2C2C2E'"
        :background-color="isheaders == 0 ? 'rgba(0, 0, 0, 0.8)' : '#f9f9f9'"
        :active-text-color="isheaders == 0 ? '#fff' : '#2C2C2E'"
        :default-active="activeIndex"
        class="el-menu-middle moblie-menu"
        mode="horizontal"
      >
        <template v-for="(item, index) in menuArr">
          <!-- 有子菜单 -->
          <el-submenu
            popper-class="test"
            v-if="item.children"
            :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            :key="index"
          >
            <template slot="title">
              <span>{{ langSet == "cn" ? item.name_cn : item.name_en }}</span>
            </template>

            <el-menu-item
              v-for="(n, i) in item.children"
              :key="i"
              :index="
                langSet == 'cn'
                  ? n.http_url_cn !== '/download'
                    ? n.http_url_cn
                    : n.http_url_cn + '/' + n.id
                  : n.http_url_en !== '/download'
                  ? n.http_url_en
                  : n.http_url_en + '/' + n.id
              "
            >
              <template>
                <span slot="title">{{
                  langSet == "cn" ? n.name_cn : n.name_en
                }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
          <!-- 没有子菜单 -->
          <el-menu-item
            v-else
            :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            :key="index"
            >{{ langSet == "cn" ? item.name_cn : item.name_en }}
            <!-- <span slot="title">{{ langSet=='cn'?item.name_cn:item.name_en }}</span> -->
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { getlistCate, getWebMenu } from "@/api/api";

export default {
  data() {
    return {
      menuArr: [],
      langSet: "",
    };
  },
  props: {
    isheaders: Number,
  },
  created() {
    localStorage.getItem("languageSet");
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";

    this.getMenu();
  },
  computed: {
    // getActive: function () {
    //   var path = this.$router.path.split("/");
    //   return path;
    // },
    activeIndex() {
      const { name, fullPath } = this.$route;
      console.log(this.$route, "this.$route");
      let rout = "";
      rout = this.$route.fullPath;
      // switch (name) {
      //   case "home":
      //     rout = fullPath;
      //     break;
      //   case "about":
      //     rout = fullPath;
      //     break;
      //   case "academic":
      //     rout =fullPath;
      //     break;
      //   case "service":
      //     rout = fullPath;
      //     break;
      //   case "download":
      //     rout = fullPath;
      //     break;
      //   case "contact":
      //     rout = fullPath;
      //     break;
      //   case "sessionHpdetail":
      //     rout = fullPath;
      //     break;
      //   case "exhibitionTraffic":
      //     rout = fullPath;
      //     break;
      //   case "download":
      //     rout = fullPath;
      //     break;
      // }

      // console.log(rout,"123")
      return rout;
    },
  },
  methods: {
    startsWithSlash(str) {
      return /^\//.test(str);
    },
    handleSelect(key, keyPath) {
      if (key) {
        if (this.startsWithSlash(key)) {
          this.$router.push({
            path: key,
          });
        } else {
          if (key == 0) {
            debugger;
            this.$emit("changjqqd");
          } else {
            let path = key;
            window.open(path, "_blank");
          }
        }
      }
    },
    getMenu() {
      let arr = [];
      let data = {
        page_type: 0,
      };
      getWebMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let lists = res.data.lists;
            localStorage.setItem("menuArr", JSON.stringify(lists));
            lists.map((item, index) => {
              if (item.is_top == "是") {
                arr.push(item);
              }
            });
            //  zhang 获取资料下载二级数据
            arr[5].children = [];
            let pid = this.langSet == "cn" ? 6 : 7;
            let data1 = { pid: pid };
            getlistCate(data1)
              .then((res) => {
                if (res.code == 1) {
                  let lists = res.data.lists;
                  lists.map((item) => {
                    arr[5].children.push({
                      name_cn: item.name,
                      name_en: item.name,
                      id: item.id,
                      http_url_cn: "/download",
                      http_url_en: "/download",
                    });
                  });
                  this.menuArr = arr;
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelectMenu(item) {
      this.$router.push({
        path: item.path,
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.headers_box {
  height: 100%;
}
.headers_slide_box {
  height: 100%;
}
.dialog {
  width: 200000px;
  height: 288px;
  background: #ffffff;
  border-radius: 12px;
  margin: auto;
  display: flex;
}
.dialog_img {
  width: 500px;
  height: 160px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.el-menu {
  width: 100%;
  height: 100%;
  display: flex;
  // padding: 0 20px;
  box-sizing: border-box;
  align-items: center;
  background: transparent !important;
}
.el-menu-item {
  font-size: 20px;
  height: 100%;
  line-height: 25px;
  flex: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .el-submenu__title {
  font-size: 20px;
  padding: 0 10px !important;
}
.el-submenu__title * {
  vertical-align: initial;
  white-space: break-spaces;
}
/deep/ .el-submenu__title i {
  display: none;
}
.el-menu.el-menu--horizontal,
.el-menu--horizontal > .el-menu-item {
  border-bottom: 0 none;
  background: transparent !important;
}
.headers_box .el-menu--horizontal > .el-menu-item:hover::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 20px;
  width: 34px;
  height: 5px;
  background: #ffffff;
  border-radius: 5px;
  transform: translateX(-50%);
}
.headers_slide_box .el-menu--horizontal > .el-menu-item:hover::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 20px;
  width: 34px;
  height: 5px;
  background: #2c2c2c;
  border-radius: 5px;
  transform: translateX(-50%);
}
.headers_box .el-menu--horizontal > .el-menu-item.is-active {
  color: #fff;
}
.headers_box .el-menu--horizontal > .el-menu-item.is-active::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 20px;
  width: 34px;
  height: 5px;
  background: #ffffff;
  border-radius: 5px;
  transform: translateX(-50%);
}
.headers_slide_box .el-menu--horizontal > .el-menu-item.is-active::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 20px;
  width: 34px;
  height: 5px;
  background: #2c2c2c;
  border-radius: 5px;
  transform: translateX(-50%);
}
.headers_slide_box .el-menu--horizontal > .el-menu-item.is-active {
  color: #2c2c2e;
}
.headers_slide_box .el-menu--horizontal > .el-menu-item.is-active::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 20px;
  width: 34px;
  height: 5px;
  background: #2c2c2e;
  border-radius: 5px;
  transform: translateX(-50%);
}
.el-menu-middle .el-menu-item,
.el-menu-middle .el-submenu__title {
  white-space: normal;
}
@media only screen and (max-width: 1100px) {
  .el-menu-item {
    font-size: 17px;
    padding: 0 5px;
  }
  /deep/ .el-submenu__title {
    font-size: 17px;
  }
}
@media only screen and (max-width: 767px) {
  .el-menu {
    position: absolute;
    width: 100%;
  }
}
</style>
<style>
.el-submenu {
  text-align: center;
  padding-right: 22px;
}
.headers_box .el-menu--horizontal > .el-submenu .el-submenu__title {
  display: flex;
  align-items: center;
  line-height: 25px;
  background: transparent !important;
}
.headers_box .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #fff;
  border-bottom: 0 none;
}
.headers_box
  .el-menu--horizontal
  > .el-submenu
  .el-submenu__title:hover::before,
.headers_box
  .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 4px;
  width: 34px;
  height: 5px;
  background: #ffffff;
  border-radius: 5px;
  transform: translateX(-50%);
}

.headers_slide_box .el-menu--horizontal > .el-submenu .el-submenu__title {
  display: flex;
  align-items: center;
  line-height: 25px;
  background: transparent !important;
}
.headers_slide_box
  .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title {
  color: #fff;
  border-bottom: 0 none;
}
.headers_slide_box
  .el-menu--horizontal
  > .el-submenu
  .el-submenu__title:hover::before,
.headers_slide_box
  .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 4px;
  width: 34px;
  height: 5px;
  background: #2c2c2c;
  border-radius: 5px;
  transform: translateX(-50%);
}
.test {
  border: none !important;
}
/* 弹出的二级菜单 */
.test .el-menu--popup {
  width: 160px;

  position: relative;
  top: -10px;
  left: -20px;
}
/* 修改二级菜单整个背景颜色 */
.test .el-menu {
  background-color: #2a2a2a;
  box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.12);
  border-radius: 5px;
}
/* 二级菜单中的子选项 */
.test .el-menu .el-menu-item {
  background-color: transparent !important;
  /* color: rgba(255, 255, 255, 0.7) !important; */
  font-weight: 400;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  text-align: center;
}
/* 被选择的子选项 */
.test .el-menu .el-menu-item:not(.is-disabled):hover {
  /* color: #fff !important; */
  border-bottom-color: #2c2c2c !important;
  width: 100%;
  text-align: center;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: rgb(44, 44, 46);
  border-bottom-color: #2c2c2c !important;
}
</style>